export enum SkillCheckResults {
    Success,
    Failure
}
